import { render, staticRenderFns } from "./legalPhone.vue?vue&type=template&id=202b12fa&scoped=true&"
import script from "./legalPhone.vue?vue&type=script&lang=js&"
export * from "./legalPhone.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/content.css?vue&type=style&index=0&id=202b12fa&scoped=true&lang=css&"
import style1 from "./legalPhone.vue?vue&type=style&index=1&id=202b12fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b12fa",
  null
  
)

export default component.exports